<script>
	import Question from "./Question.svelte";
	import Count from "./Count.svelte";
	import Outro from "./Outro.svelte";
	import Pixel from "./Pixel.svelte";
	import questions from "./Questions";

	import { onMount } from "svelte";

	const trackingImgString =
		"https://ad.doubleclick.net/ddm/trackimp/N5457.273668.IRISHINDEPENDENT/B26512751.315090835;dc_trk_aid=510508045;dc_trk_cid=157829181;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=?";

	let loaded = false;
	let selected = 0;

	$: calculateScore = () =>
		questions.filter((q) => q.correct.indexOf(q.selected) > -1).length;

	$: score = calculateScore();

	onMount(() => {
		if ("ontouchstart" in document) {
			document.body.classList.remove("no-touch");
		}
		setTimeout(() => (loaded = true), 100);
	});
</script>

<main>
	<h1>How well do you know TG4?</h1>
	{#if loaded}
		{#each questions as question, i}
			{#if selected == i}
				<Question bind:selected bind:data={question} />
			{/if}
		{/each}

		{#if selected !== "outro"} <Count {selected} />{/if}

		{#if selected == "outro"}
			<Outro {score} />
		{/if}

		<Pixel {selected} active={true} />
	{/if}
</main>
{#if loaded}
	<Pixel selected="loaded" active={true} />
{/if}
<img
	src={trackingImgString}
	border="0"
	height="1"
	width="1"
	alt="Advertisement"
/>

<style>
	main {
		--height: 440px;
		--countHeight: 30px;
		margin: 0 auto;
		padding: 0 0.5rem;
		height: var(--height);
		max-width: 550px;
		position: relative;
		overflow: hidden;
		text-align: center;
	}
	h1 {
		color: var(--accent);
		text-align: center;
		display: grid;
		font-size: 24px;
		align-items: center;
		height: calc(var(--height) * 0.1);
	}
	:global(#nc-tg4, #nc-tg4 h1, #nc-tg4 p, #nc-tg4 a, #nc-tg4 span) {
		box-sizing: border-box;
		font-family: "TG4 Regular", sans-serif !important;
	}
</style>
